module.exports = __webpack_public_path__ + "media/images/photos/man-and-woman-inspecting-damage-31acc8226f98b129c7b44ca9c0b1a45e.jpg";